import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ParcelFinderStartGuide from '../start-guides/ParcelFinderStartGuide';
import ParcelFinderPage from '../parcel-finder/ParcelFinderPage';
import ClaimsCenterPage from '../claims-center/ClaimsCenterPage';
import withShopSettingsRedirect from '../../wrappers/withShopSettingsRedirect';
import ShipmentDetailsPage from '../parcel-finder/ShipmentDetailsPage/ShipmentDetailsPage';
import OrderDetailsPage from '../parcel-finder/OrderDetailsPage/OrderDetailsPage';
import { ApolloProvider } from '@apollo/client';
import { notificationsClient } from '../../notifications/graphql/notificationsClient';
import ClaimsCenterMaintenancePage from '../claims-center/ClaimsCenterMaintenancePage';
import { withReadyUnleash } from '../../wrappers/withReadyUnleash';
import { withMaintenanceRedirect } from '../../wrappers/withMaintenanceRedirect';

const withParcelFinderAccess = withShopSettingsRedirect('isClaimsEnabled', '/parcel-finder/start-guide');
const withClaimsCenterMaintenanceRedirect = withMaintenanceRedirect(
  'claims-maintenance',
  '/parcel-finder/claims-center/maintenance'
);
const ClaimsCenterPageWithAccess = withClaimsCenterMaintenanceRedirect(withParcelFinderAccess(ClaimsCenterPage));

function ParcelFinderRoutes() {
  return (
    <ApolloProvider client={notificationsClient}>
      <Switch>
        <Route exact path="/parcel-finder" component={ParcelFinderPage} />
        <Route exact path="/parcel-finder/claims-center" component={ClaimsCenterPageWithAccess} />
        <Route exact path="/parcel-finder/claims-center/maintenance" component={ClaimsCenterMaintenancePage} />
        <Route exact path="/parcel-finder/start-guide" component={ParcelFinderStartGuide} />
        <Route exact path="/parcel-finder/shipments/:id(\d+)" component={ShipmentDetailsPage} />
        <Route exact path="/parcel-finder/orders/:id(\d+)" component={OrderDetailsPage} />
        <Redirect to="/parcel-finder" />
      </Switch>
    </ApolloProvider>
  );
}

export default withReadyUnleash(ParcelFinderRoutes);
